const baseUrl = "https://manufacturer-xvzb.onrender.com";

export default baseUrl;
